// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"ab837ab7","726":"c35372cb"}[chunkId] + ".chunk.js";
};